import { render } from "./ScrollTopArrow.vue?vue&type=template&id=cb600530"
import script from "./ScrollTopArrow.vue?vue&type=script&lang=js"
export * from "./ScrollTopArrow.vue?vue&type=script&lang=js"

import "./ScrollTopArrow.vue?vue&type=style&index=0&id=cb600530&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__